import moment from "moment-timezone"

// 時段菜單：依店層級設定、通路與台北時間判斷可顯示的分類。
export const LINE_CHANNEL_FIELD = 'readByLine'

export const getTaipeiTimePoint = (date = new Date()) => {
    const taipeiDate = moment(date).tz('Asia/Taipei')
    return { weekday: taipeiDate.isoWeekday(), minute: taipeiDate.hours() * 60 + taipeiDate.minutes() }
}

// "HH:mm" → 當日第幾分鐘；格式不符回傳 null（例：零售自取 pickupTime 為 null）
export const parseTimeToMinute = (time) => {
    const match = /^(\d{1,2}):(\d{1,2})$/.exec(String(time ?? '').trim())
    if (!match) return null
    const hour = Number(match[1])
    const minute = Number(match[2])
    if (hour > 23 || minute > 59) return null
    return hour * 60 + minute
}

// 只解析日曆日期，不以裝置時區換算；星期採 ISO（1＝週一…7＝週日）。
export const parseDateToWeekday = (date) => {
    if (typeof date !== 'string') return null
    const parsedDate = moment.utc(date, ['YYYY/MM/DD', 'YYYY-MM-DD'], true)
    return parsedDate.isValid() ? parsedDate.isoWeekday() : null
}

// null＝無設定、不限制；非空清單即進入限制模式，壞資料不應放寬顯示。
export const normalizeMenuTimeSettings = (list) => {
    if (!Array.isArray(list) || list.length === 0) return null
    return list.reduce((settings, setting) => {
        const startMinute = setting?.startMinute
        const endMinute = setting?.endMinute
        if (!Number.isInteger(startMinute) || startMinute < 0 || startMinute > 1439 ||
            !Number.isInteger(endMinute) || endMinute < 0 || endMinute > 1439) return settings
        settings.push({
            startMinute,
            endMinute,
            weekdays: Array.isArray(setting.weekdays)
                ? setting.weekdays.filter(day => Number.isInteger(day) && day >= 1 && day <= 7) : [],
            goodsCategoryIds: Array.isArray(setting.goodsCategoryIds)
                ? setting.goodsCategoryIds.filter(id => typeof id === 'string').map(id => id.trim()).filter(Boolean) : [],
            readByLine: setting.readByLine === true
        })
        return settings
    }, [])
}

// 同日區間左閉右開；跨午夜的凌晨時段算在開始那天，start === end 為全天。
export const isSettingActive = (setting, channelField, { weekday, minute }) => {
    if (setting[channelField] !== true) return false
    const yesterday = weekday === 1 ? 7 : weekday - 1
    const { startMinute: s, endMinute: e, weekdays } = setting
    if (s === e) return weekdays.includes(weekday)
    if (s < e) return weekdays.includes(weekday) && minute >= s && minute < e
    return (weekdays.includes(weekday) && minute >= s)
        || (weekdays.includes(yesterday) && minute < e)
}

export const getVisibleCategoryIds = (settings = null, channelField, timePoint) => {
    if (settings === null) return null
    const visible = new Set()
    for (const setting of settings) {
        if (isSettingActive(setting, channelField, timePoint)) {
            setting.goodsCategoryIds.forEach((id) => visible.add(id))
        }
    }
    return visible
}

export const isCategoryInVisibleSet = (visibleIds, categoryId) => visibleIds === null || visibleIds.has(categoryId)

// 時段菜單以「顧客選擇的時間」判斷的點餐方式；其餘（內用、外帶、零售自取、零售宅配）以現在時間判斷
export const SELECTED_TIME_BASED_METHODS = ['pickUp', 'delivery']

// 預約取餐 / 外送採選定日期與時間；缺日期時沿用今天的星期，缺時間則退回現在。
export const getTimeSlotReferencePoint = ({ method, pickupDate, pickupTime, now = getTaipeiTimePoint() }) => {
    if (!SELECTED_TIME_BASED_METHODS.includes(method)) return now
    const selectedMinute = parseTimeToMinute(pickupTime)
    if (selectedMinute === null) return now
    return { weekday: parseDateToWeekday(pickupDate) ?? now.weekday, minute: selectedMinute }
}
